const pageNameKey = "alarmListToolbar";

export const alarmListToolbarEn = {
  [pageNameKey]: {
    addRecipients: "Manage Recipients",
    viewRecipients: "View Recipients",
    createAlarmProfile: "Manage Condition Monitoring Profiles",
    viewAlarmProfiles: "View Condition Monitoring Profiles",
    searchHint: "Use Ctrl-F to search",
  },
};

export const alarmListToolbarPtBr = {
  [pageNameKey]: {
    addRecipients: "Gerenciar destinatários",
    viewRecipients: "Ver destinatários",
    createAlarmProfile: "Gerenciar perfis de monitoramento de condições",
    viewAlarmProfiles: "Ver Perfis de Monitoramento de condição",
    searchHint: "Use Ctrl-F para pesquisar",
  },
};

export const alarmListToolbarDe = {
  [pageNameKey]: {
    addRecipients: "Empfänger verwalten",
    viewRecipients: "Empfänger anzeigen",
    createAlarmProfile: "Condition-Monitoring-Profile verwalten",
    viewAlarmProfiles: "Condition-Monitoring-Profile anzeigen",
    searchHint: "Verwende Strg-F zum Suchen",
  },
};

export const alarmListToolbarZhHans = {
  [pageNameKey]: {
    addRecipients: "管理接收者",
    viewRecipients: "查看接收者",
    createAlarmProfile: "管理条件监控配置文件",
    viewAlarmProfiles: "查看条件监控配置文件",
    searchHint: "使用 Ctrl-F 进行搜索",
  },
};

export const alarmListToolbarIt = {
  [pageNameKey]: {
    addRecipients: "Gestisci destinatari",
    viewRecipients: "Visualizza destinatari",
    createAlarmProfile: "Gestire i profili di monitoraggio delle condizioni",
    viewAlarmProfiles: "Visualizza i profili di monitoraggio delle condizioni",
    searchHint: "Usa Ctrl-F per cercare",
  },
};

export const alarmListToolbarEs = {
  [pageNameKey]: {
    addRecipients: "Administrar destinatarios",
    viewRecipients: "Ver destinatarios",
    createAlarmProfile: "Administrar perfiles de monitorización de condiciones",
    viewAlarmProfiles: "Ver perfiles de monitorización del estado",
    searchHint: "Usa Ctrl-F para buscar",
  },
};

export const alarmListToolbarNl = {
  [pageNameKey]: {
    addRecipients: "Ontvangers beheren",
    createAlarmProfile: "Conditiebewakingsprofielen beheren",
    searchHint: "Gebruik Ctrl-F om te zoeken",
    viewAlarmProfiles: "Conditiebewakingsprofielen weergeven",
    viewRecipients: "Ontvangers weergeven",
  },
};

export const alarmListToolbarTr = {
  [pageNameKey]: {
    addRecipients: "Alıcıları Yönet",
    createAlarmProfile: "Durum İzleme Profillerini Yönetin",
    searchHint: "Aramak için Ctrl-F tuşlarını kullanın",
    viewAlarmProfiles: "Durum İzleme Profillerini Görüntüle",
    viewRecipients: "Alıcıları Görüntüle",
  },
};
